var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common_contents_wrap", attrs: { id: "contact" } },
    [
      _c("h2", [_vm._v("CONTACT")]),
      _vm._v(" "),
      _vm.isSubmitComplete
        ? _c("p", [
            _vm._v(
              "\n\t\tお問い合わせありがとうございます。送信完了しました！"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n\t\tご入力いただいたメールアドレスにお問い合わせ内容を送信しましたのでご確認ください。自動送信メールが届いていない場合、何らかの理由でメールの送信に失敗している可能性があります。お手数ですが、下記メールアドレスへお問い合わせ内容を送信してください。"
            ),
            _c("br"),
            _vm._v("\n\t\tarais.portfolio.contact@gmail.com"),
            _c("br")
          ])
        : _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              },
              [
                _c("table", { staticClass: "contact_form_table" }, [
                  _c("tbody", [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            }
                          ],
                          attrs: {
                            id: "email",
                            type: "email",
                            name: "entry.1284114612",
                            required: ""
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            }
                          ],
                          attrs: {
                            id: "name",
                            type: "text",
                            name: "entry.61785260",
                            required: ""
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title,
                              expression: "title"
                            }
                          ],
                          attrs: {
                            id: "title",
                            type: "text",
                            name: "entry.1987260132",
                            required: ""
                          },
                          domProps: { value: _vm.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.title = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("td", [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message,
                              expression: "message"
                            }
                          ],
                          attrs: {
                            id: "message",
                            name: "entry.124930197",
                            required: ""
                          },
                          domProps: { value: _vm.message },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.message = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(6)
                  ])
                ])
              ]
            )
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n\t\t\t管理人ＡＲＡＩへのコンタクトはこちらから！"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "2" } }, [_vm._v("ＣＯＮＴＡＣＴ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("label", { attrs: { for: "email" } }, [_vm._v("Ｅ－ＭＡＩＬ")]),
      _vm._v(" "),
      _c("span", { staticClass: "force_color" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("label", { attrs: { for: "name" } }, [_vm._v("ＮＡＭＥ")]),
      _vm._v(" "),
      _c("span", { staticClass: "force_color" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("label", { attrs: { for: "title" } }, [_vm._v("ＴＩＴＬＥ")]),
      _vm._v(" "),
      _c("span", { staticClass: "force_color" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _c("label", { attrs: { for: "message" } }, [_vm._v("ＭＥＳＳＡＧＥ")]),
      _vm._v(" "),
      _c("span", { staticClass: "force_color" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("input", { attrs: { type: "submit", value: "送信" } }),
        _vm._v(" "),
        _c("input", { attrs: { type: "reset", value: "リセット" } })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }